export default "__VITE_ASSET__fafb3f8e__"